import React, { FC } from "react";

import Button from "../../../../../components/elements/Button";
import CheckBox from "../../../../../components/elements/CheckBox";
import SelectWithCheckboxes from "../../../../../components/elements/SelectWithCheckboxes";
import classes from "../../SelectHubspotTargetCompaniesSlide.module.scss";
import { SelectOptionType } from "../../../../../components/elements/Select/Select";

type ProfileTierSelectorProps = {
  tierValue: string[];
  options: SelectOptionType[];
  areTargetAccountsOnly: boolean;
  handleAreTargetsAccountOnlyChange: (event: React.ChangeEvent<{}>, checked: boolean) => void;
  handleGetCompanyNames: () => void;
  handleProfileTierChange: (e: any) => void;
};

const ProfileTierSelector: FC<ProfileTierSelectorProps> = ({
  tierValue,
  options,
  areTargetAccountsOnly,
  handleAreTargetsAccountOnlyChange,
  handleGetCompanyNames,
  handleProfileTierChange,
}) => {
  return (
    <div className={classes.profileTierSelectorContainer}>
      <div className={classes.selector}>
        <SelectWithCheckboxes
          className={classes.selector}
          label="Select Profile Tiers"
          options={options}
          value={tierValue}
          onChange={handleProfileTierChange}
        />
      </div>
      <div className={classes.selectorControls}>
        <Button onClick={handleGetCompanyNames}>Get Company Names</Button>

        <CheckBox
          label="Get Target Accounts Only"
          value={areTargetAccountsOnly}
          onChange={handleAreTargetsAccountOnlyChange}
        />
      </div>
    </div>
  );
};

export default ProfileTierSelector;
